import React, { useState, useCallback, useEffect } from 'react';
import { CreateTableOld2 as CreateTable2 } from '../EmployeeTables/EmployeeTable';

import axios from '../../../../api/apiClient';
import {
	domain,
	token
} from '../../../Security';
import { AddUpdateRequirementModal } from '../EmployeeFormFld/RequirementsForm';

import loadingSpinner from '../../../../assets/loading.gif';

// icons
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
/* MODIFIED: Added icon for the new button */
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import { Button } from '../../../../common/APICommon';
import { RequirementCategorySelect } from '../../../../common/selectComponents/RequirementCategorySelect';

export function RequirementsTab({ viewedData, isEditMode }) {
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(false);

	/* MODIFIED: Added states for Category selection */
	const [categories, setCategories] = useState([]);
	const [selectedCategory, setSelectedCategory] = useState("");
	const [showCategoryModal, setShowCategoryModal] = useState(false);

	//Request Messages -start
	const [showRequestMessage, setShowRequestMessage] = useState(false);
	const [requestMessage, setRequestMessage] = useState("");
	const [isSuccess, setIsSuccess] = useState("");
	useEffect(() => {
		if (showRequestMessage) {
			const timeoutId = setTimeout(() => {
				setShowRequestMessage(false);
			}, 5000);

			return () => clearTimeout(timeoutId);
		}

	}, [showRequestMessage]);
	function GenerateMessage({ form, message, isSuccess }) {
		return (
			<>
				<div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
					{form && (
						<div className="modal toggleMessage" style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}>
							<div className='column'>
								{isSuccess ?
									<div className='request_title row' style={{ fontWeight: "bold", color: "green", alignItems: "center" }}>
										<CheckCircleIcon />
										<span >{"SUCCESS MESSAGE"}</span>
									</div>
									:
									<div className='request_title row' style={{ fontWeight: "bold", color: "#DD5746", alignItems: "center" }}>
										<ErrorIcon />
										<span>{"ERROR MESSAGE"}</span>
									</div>
								}
								<span style={{ textAlign: "center", padding: "10px 0", color: isSuccess ? "green" : "#DD5746" }}>{message}</span>
							</div>
						</div>
					)}
				</div>
			</>
		);
	}
	//Request Messages -end

	const header = [
		'Requirement',
		'Category',
		'File',
		'Has Completed?',
		'Is Active?',
		''
	]
	const accessor = [
		'onBoardingRequirementsDescription',
		'requirementCategory',
		'file',
		'hasCompleted',
		'isActive',
		'manage'
	]

	const [onBoardingRequirements, setOnBoardingRequirements] = useState(null);
	const [file, setFile] = useState(null);
	const [hasCompleted, setHasCompleted] = useState(false);
	const [isActive, setIsActive] = useState(false);

	const resetLocalVariable = () => {
		setOnBoardingRequirements(null)
		setFile(null)
		setHasCompleted(false)
		setIsActive(false)
		/* MODIFIED: Reset category selection */
		setSelectedCategory("")
	}

	const fetchData = useCallback(async () => {
		const apiUrl = domain + `/api/OnBoarding/employee/${viewedData.employeeId}`;

		try {
			setLoading(true);
			const response = await axios.get(apiUrl, {
				headers: {
					'Authorization': `Bearer ${token}`,
					'Content-Type': 'application/json' // You can include other headers if needed
				}
			})
			setData(response?.data); // Set the response data to the state
		} catch (error) {
			console.error('Error fetching data:', error);
		} finally {
			setLoading(false); // Set loading state to false after data fetching is complete
		}
	}, [viewedData]);

	/* MODIFIED: Fetch Categories for the dropdown */
	const fetchCategories = useCallback(async () => {
		try {
			const response = await axios.get(domain + "/api/RequirementCategory", {
				headers: { 'Authorization': `Bearer ${token}` }
			});
			setCategories(response?.data || []);
		} catch (error) {
			console.error('Error fetching categories:', error);
		}
	}, []);

	useEffect(() => {
		fetchData();
		fetchCategories(); /* MODIFIED: Trigger category fetch */
	}, [fetchData, fetchCategories])

	const [selectedData, setSelectedData] = useState(null);
	const [showAddForm, setShowAddForm] = useState(false);
	const openAddForm = () => {
		setShowAddForm(true)
	}
	const closeAddForm = () => {
		setShowAddForm(false)
		resetLocalVariable()
	}

	/* MODIFIED: Category Modal handlers */
	const openCategoryModal = () => setShowCategoryModal(true);
	const closeCategoryModal = () => {
		setShowCategoryModal(false);
		resetLocalVariable();
	}

	const fileToBase64 = (file) => {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => resolve(reader.result.split(",")[1]); // get Base64 without prefix
			reader.onerror = (error) => reject(error);
		});
	};

	const handleAdd = async () => {
		const apiUrl = domain + "/api/OnBoarding/requirement";
		const base64File = file ? await fileToBase64(file) : null;

		const _data = {
			onBoardingId: data.id ? data.id : 0,
			employeePersonalInformationId: viewedData.id,
			onBoardingRequirementsId: onBoardingRequirements.id,
			file: base64File, // backend must decode this into byte[]
			fileName: file?.name ?? null,
			hasCompleted: hasCompleted,
			isActive: isActive,
		};

		try {
			setLoading(true);
			await axios.post(apiUrl, _data, {
				headers: {
					'Authorization': `Bearer ${token}`,
					'Content-Type': 'application/json'
				}
			});

			await fetchData();

			console.log('Data added successfully');
			setShowRequestMessage(true);
			setIsSuccess(true);
		} catch (error) {
			setLoading(false);
			console.error('There was a problem adding data:', error);
			setShowRequestMessage(true);
			setIsSuccess(false);
			const errorMessage = error.response?.data?.message || "An error occurred";
			setRequestMessage(errorMessage);
		} finally {
			setLoading(false);
		}
	};

	/* MODIFIED: Requirement 1 & 2 - Save ID and Send to bulk-requirement-by-category */
	const handleBulkAddByCategory = async () => {
		if (!selectedCategory) {
			alert("Please select a category");
			return;
		}

		const apiUrl = domain + "/api/OnBoardingRequirements/bulk-requirement-by-category";
		const _data = {
			onBoardingId: data.id ? data.id : 0,
			employeePersonalInformationId: viewedData.id,
			requirementCategoryId: parseInt(selectedCategory)
		};

		try {
			setLoading(true);
			await axios.post(apiUrl, _data, {
				headers: {
					'Authorization': `Bearer ${token}`,
					'Content-Type': 'application/json'
				}
			});

			await fetchData();
			setShowCategoryModal(false);
			setShowRequestMessage(true);
			setIsSuccess(true);
		} catch (error) {
			console.error('Error adding by category:', error);
			setShowRequestMessage(true);
			setIsSuccess(false);
			const errorMessage = error.response?.data?.message || "An error occurred while adding bulk requirements";
			setRequestMessage(errorMessage);
		} finally {
			setLoading(false);
		}
	};

	const [showEditForm, setShowEditForm] = useState(false);
	const openEditForm = () => {
		setShowEditForm(true)
	}
	const closeEditForm = () => {
		setShowEditForm(false)
		resetLocalVariable()
	}
	const handleUpdate = async (event) => {
		const apiUrl = domain + "/api/OnBoarding/requirement";
		const base64File = file ? await fileToBase64(file) : null;

		const _data = {
			onBoardingId: data.id,
			onBoardingRequirementsId: onBoardingRequirements.id,
			file: base64File, // backend must decode this into byte[]
			fileName: file?.name ?? null,
			hasCompleted: hasCompleted,
			isActive: isActive,
		};

		try {
			setLoading(true);
			await axios.put(apiUrl + `/${selectedData.id}`, _data, {
				headers: {
					'Authorization': `Bearer ${token}`,
					'Content-Type': 'application/json'
				}
			});

			await fetchData();

			console.log('Data updated successfully');
			setShowRequestMessage(true);
			setIsSuccess(true);
		} catch (error) {
			setLoading(false);
			console.error('There was a problem updating data:', error);
			setShowRequestMessage(true);
			setIsSuccess(false);
			const errorMessage = error.response?.data?.message || "An error occurred";
			setRequestMessage(errorMessage);
		} finally {
			setLoading(false);
		}
	};

	const editHandleClick = (data) => {
		setSelectedData(data);
		const reqData = {
			id: data.onBoardingRequirementsId,
			description: data.onBoardingRequirementsDescription
		}

		// ✅ If there's a file from backend, reconstruct it
		if (data.file) {
			const binaryData = atob(data.file); // decode base64

			const arrayBuffer = new ArrayBuffer(binaryData.length);
			const uint8Array = new Uint8Array(arrayBuffer);

			for (let i = 0; i < binaryData.length; i++) {
				uint8Array[i] = binaryData.charCodeAt(i);
			}

			// use mimeType + fileName if you store them in DB
			const mimeType = data.mimeType || "application/octet-stream";
			const fileName = data.fileName;

			const blob = new Blob([uint8Array], { type: mimeType });
			const file = new File([blob], fileName, { type: mimeType });

			setFile(file); // ✅ now your state is a real File object
		} else {
			setFile(null);
		}

		setOnBoardingRequirements(reqData)
		setHasCompleted(data.hasCompleted)
		setIsActive(data.isActive)
		openEditForm()
	}
	const downloadHandleClick = async (data) => {
		try {
			setLoading(true); // ✅ start loading

			if (data.file) {
				const binaryData = atob(data.file); // decode base64

				const arrayBuffer = new ArrayBuffer(binaryData.length);
				const uint8Array = new Uint8Array(arrayBuffer);

				for (let i = 0; i < binaryData.length; i++) {
					uint8Array[i] = binaryData.charCodeAt(i);
				}

				// use mimeType + fileName if you store them in DB
				const mimeType = data.mimeType || "application/octet-stream";
				const fileName = data.fileName || "download";

				const blob = new Blob([uint8Array], { type: mimeType });
				const file = new File([blob], fileName, { type: mimeType });

				const url = URL.createObjectURL(file);
				const link = document.createElement("a");
				link.href = url;
				link.download = fileName;
				link.click();

				URL.revokeObjectURL(url);
			} else {
				console.warn("No file data found.");
			}
		} catch (error) {
			console.error("Error downloading file:", error);
		} finally {
			setLoading(false); // ✅ always end loading
		}
	};

	return (
		<>
			<div className="family-tab-top mb-2" style={{ display: isEditMode ? "flex" : "none", justifyContent: "start", gap: "10px" }}>
				{/* {CreateButton("addEmployee-family-add", "add row", () => openAddForm(), "ADD", GroupAddIcon)} */}
				<Button
					icon={<NoteAddIcon />}
					name={"ADD"}
					className={"bg-customGreen hover:bg-customGreenHover border-none"}
					onClick={openAddForm}
				/>
				{/* MODIFIED: Added New Button "Add by Category" */}
				{/* {CreateButton("addEmployee-category-add", "add by category", () => openCategoryModal(), "ADD BY CATEGORY", PlaylistAddIcon)} */}
				<Button
					icon={<PlaylistAddIcon />}
					name={"ADD BY CATEGORY"}
					className={"bg-customGreen hover:bg-customGreenHover border-none"}
					onClick={openCategoryModal}
				/>
			</div>
			<div className="family-tab-body">
				<div className="employeesTab-table container">
					<CreateTable2
						dataList={data?.requirements}
						dataHeader={header}
						dataAccessor={accessor}
						editHandleClick={editHandleClick}
						downloadHandleClick={downloadHandleClick}
						isEditMode={isEditMode}
					/>
					{data?.requirements?.length > 0 ? (
						<div></div>
					)
						:
						(
							<div> {/*<p>No records to display</p>*/}</div>
						)}
				</div>
			</div>

			{/* MODIFIED: New Selection Modal for Category */}
			<div className={`modal-overlay ${showCategoryModal ? 'open' : ''}`}>
				<div className="modal" style={{ width: "400px", padding: "20px" }}>
					<h3 className="mb-5 text-xl font-semibold">Select Requirement Category</h3>
					<div className="my-7">
						<RequirementCategorySelect
							value={selectedCategory}
							setValue={setSelectedCategory}
						/>
					</div>
					<div className="flex justify-end space-x-2">
						<button
							className="cursor-pointer rounded-md border-none bg-blue-600 px-4 py-2 text-white transition hover:bg-blue-700"
							onClick={handleBulkAddByCategory}
							disabled={!selectedCategory}
						>
							Save
						</button>
						<button
							className="cursor-pointer rounded-md border-none bg-red-600 px-4 py-2 text-white transition hover:bg-red-700"
							onClick={closeCategoryModal}
						>
							Cancel
						</button>
					</div>
				</div>


			</div>

			<AddUpdateRequirementModal
				visible={showAddForm}
				onClose={closeAddForm}
				onSave={handleAdd}
				modalName={"Add Data"}

				data={data}
				onBoardingRequirements={onBoardingRequirements} setOnBoardingRequirements={setOnBoardingRequirements}
				file={file} setFile={setFile}
				hasCompleted={hasCompleted} setHasCompleted={setHasCompleted}
				isActive={isActive} setIsActive={setIsActive}
			/>

			<AddUpdateRequirementModal
				visible={showEditForm}
				onClose={closeEditForm}
				onSave={handleUpdate}
				modalName={"Update Data"}

				data={data}
				onBoardingRequirements={onBoardingRequirements} setOnBoardingRequirements={setOnBoardingRequirements}
				file={file} setFile={setFile}
				hasCompleted={hasCompleted} setHasCompleted={setHasCompleted}
				isActive={isActive} setIsActive={setIsActive}
			/>

			<GenerateMessage form={showRequestMessage}
				message={isSuccess ? "Request Success!" : requestMessage}
				isSuccess={isSuccess}
			>
			</GenerateMessage>

			{loading ? (
				<div
					style={{
						position: "fixed",
						top: "0",
						left: "0",
						width: "100vw",
						height: "100vh",
						zIndex: "5000",
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						justifyContent: "center",
						textAlign: "center",
						backgroundColor: "#ffffff59",
					}}
				>
					<img src={loadingSpinner} alt="Loading..." />
				</div>
			) : (
				<></>
			)
			}
		</>
	)
}